import { Games } from "./components/Games";

export default Games;
